const TOKEN_KEY = 'inscricao_token'
const ADMIN_KEY = 'inscricao_admin'

export function getToken() { return localStorage.getItem(TOKEN_KEY) }
export function setToken(t) { localStorage.setItem(TOKEN_KEY, t) }
export function getAdmin() {
  const v = localStorage.getItem(ADMIN_KEY)
  return v ? JSON.parse(v) : null
}
export function setAdmin(a) { localStorage.setItem(ADMIN_KEY, JSON.stringify(a)) }
export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ADMIN_KEY)
}
export function isAuthenticated() { return !!getToken() }
export function getAdminRole() { return getAdmin()?.role || null }
